(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-letters/assets/javascripts/bingo-letters.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-letters/assets/javascripts/bingo-letters.js');
"use strict";


const cdn = svs.core.config.data.svsconfig.cdn;
const BingoLetters = _ref => {
  let letters = _ref.letters;
  return React.createElement(React.Fragment, null, letters.map(letter => React.createElement("img", {
    alt: letter,
    key: letter,
    src: "".concat(cdn, "/images/bingo-react/logotype-letters/").concat(letter, ".svg")
  })));
};
setGlobal('svs.bingo_react.components.BingoLetters', BingoLetters);

 })(window);